var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8008 0.5C28.908 0.500036 37.1016 8.69366 37.1016 18.8008C37.1015 28.9078 28.9079 37.1015 18.8008 37.1016C8.69363 37.1016 0.50009 28.9079 0.5 18.8008C0.5 8.69363 8.69357 0.5 18.8008 0.5Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1611 11.9863L19.5078 17.0029L19.5244 17.0283L19.5439 17.0049L23.7363 11.9863H24.8232L20.0264 17.7305H19.9932L20.0166 17.7656L25.2529 25.6143H21.4385L17.9043 20.3154L17.8877 20.29L17.8682 20.3135L13.4414 25.6143H12.3545L17.3936 19.5801L17.4043 19.5664L17.3955 19.5527L12.3477 11.9863H16.1611ZM13.8457 12.8652L17.9336 18.8877L18.4404 19.6328H18.4395L18.4482 19.6455L21.9473 24.8008L21.9541 24.8105H23.7686L23.7441 24.7754L19.4561 18.457L18.9424 17.7002L15.6436 12.8398L15.6367 12.8301H13.8223L13.8457 12.8652Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.0450206
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.765332d94ae1416700882e0d0a62c8dd.svg";
export { ForwardRef as ReactComponent };